import { render, staticRenderFns } from "./FooterConfig.vue?vue&type=template&id=139460c8&scoped=true"
import script from "./FooterConfig.vue?vue&type=script&lang=js"
export * from "./FooterConfig.vue?vue&type=script&lang=js"
import style0 from "./FooterConfig.vue?vue&type=style&index=0&id=139460c8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139460c8",
  null
  
)

export default component.exports